import React, { useEffect, useState } from 'react'
import axios from 'axios'
import BackButton from '../ChildComponent/BackButton'
import COLORS from '../resources/colors/COLORS'
import SessionManager from '../Utils/SessionManager'
import myToast from '../Utils/MyToast'
import MyLoader from '../Spinner/MyLoader'
import '../css/Admin_css/admin-customize.css'

const FontSettings = () => {
  const [loading, setLoading] = useState(false)
  const [fontSettings, setFontSettings] = useState([])

  useEffect(() => {
    window.scrollTo(0, 0)
    fetchAllSampleFontSettings()
  }, [])

  const fetchAllSampleFontSettings = async () => {
    try {
      setLoading(true)
      const schoolCode = SessionManager.getSchoolCode && SessionManager.getSchoolCode()
      
      if (!schoolCode) {
        myToast.notify_warning('School code not found')
        return
      }

      const FUNCTION_NAME = 'getAllSampleFontSettings.php'
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`
      
      const response = await axios.get(URL, {
        params: {
          school_code: schoolCode
        }
      })

      if (response.data?.api_status === 'OK') {
        setFontSettings(response.data.data || [])
        if (response.data.data && response.data.data.length > 0) {
          console.log('Font settings loaded:', response.data.data.length)
        } else {
          console.log('No font settings found')
        }
      } else {
        myToast.notify_warning(response.data?.api_remark || 'Failed to load font settings')
        setFontSettings([])
      }
    } catch (error) {
      console.error('Error fetching font settings:', error)
      myToast.notify_error('Failed to load font settings')
      setFontSettings([])
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <MyLoader />
  }

  return (
    <div className="content">
      <div className="content-header d-flex justify-content-between align-items-center">
        <div className="leftside-content-header d-flex align-items-center">
          <i
            className="fa fa-home"
            aria-hidden="true"
            style={{ fontSize: '18px', color: COLORS.primary_color, cursor: 'pointer', marginRight: '10px' }}
            onClick={() => (window.location.href = '/AdminMain')}
          />
          <ul className="breadcrumbs mb-0">
            <li>Settings</li>
            <li>Font Settings</li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="row bg_page_white_rounded" style={{ '--mMargin': '50px' }}>
        <div className="col-sm-12">
          <div className="row box_shadow bg_card_blue_outline" style={{ padding: 2, margin: '10px 0px 10px 0px' }}>
            <div className="col-sm-12" style={{ height: '100%', margin: 0, padding: '5px', display: 'flex', flexDirection: 'column' }}>
              <h6 style={{ margin: '2px 0 4px 0', fontSize: '16px', fontWeight: '700', color: 'white', backgroundColor: '#f97316', padding: '8px 12px', borderRadius: '6px', display: 'inline-block' }}>
                <i className="fa fa-font" style={{ marginRight: '8px' }} />
                Font Settings
              </h6>
              <div style={{ padding: '8px 4px', color: '#374151' }}>
                {fontSettings.length > 0 ? (
                  <div>
                    <p style={{ marginBottom: '12px', fontWeight: '600' }}>Found {fontSettings.length} sample(s) with font settings</p>
                    {/* Add your UI to display/edit font settings here */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {fontSettings.map((sample, index) => (
                        <div key={index} style={{ 
                          padding: '12px', 
                          border: `1px solid ${COLORS.grey3}`, 
                          borderRadius: '6px',
                          background: COLORS.white
                        }}>
                          <div style={{ fontWeight: '600', marginBottom: '8px', color: COLORS.primary_color_shade7 }}>
                            {sample.sample_name || sample.sample_id}
                          </div>
                          {sample.FontSetting && sample.FontSetting.length > 0 && (
                            <div style={{ fontSize: '13px', color: COLORS.text_light }}>
                              {sample.FontSetting.length} font setting(s) available
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <p>No font settings found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FontSettings


